import { useState } from 'react';
import ApiService from '../Services/ApiService';

const useIniciarVenta = () => {
    const { REACT_APP_APIPAYWALL } = process.env;
    const [isLoading, setIsLoading] = useState(null);
    const [dataIframe, setDataIframe] = useState(null);
    const [error, setError] = useState(null);

    const outFunc = async (data, correlationId, send) => {
        setIsLoading(true);
        const payload = {
            
                SitioOrigen: data.SitioOrigen,
                planId: data.planId,
                campaniaId: data.campaniaId,
                idCanalDeVenta: data.idCanalDeVenta,
                idFormaDeContacto: data.idFormaDeContacto,
                clienteModel: data.clienteModel,
                domicilioModel: data.domicilioModel,        
                correlationId : correlationId           
        };
        
        await ApiService.post(`${REACT_APP_APIPAYWALL}Venta/IniciarVenta`, payload)
            .then((data) => {
                if (data && data.code === '0000') {
                    setDataIframe(data.response);
                    setIsLoading(false);
                } else {
                    setError('error');
                    setIsLoading(false);
                }
            })
            .catch((error) => {
                setError(error);
                setIsLoading(false);
                send('ERROR')
            });
    };

    return [dataIframe, error, isLoading, outFunc];
};

export default useIniciarVenta;
